var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_3987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 14.6606H14.6608",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23846 11.5951L2.66578 11.3285L1.33301 8.66298L2.06603 8.29647C2.25206 8.20273 2.45747 8.1539 2.66578 8.1539C2.87409 8.1539 3.0795 8.20273 3.26553 8.29647L3.37882 8.36311C3.56485 8.45685 3.77026 8.50568 3.97857 8.50568C4.18688 8.50568 4.39229 8.45685 4.57831 8.36311L5.33133 7.9966L3.33217 3.99827L3.93192 3.6984C4.15361 3.58934 4.40125 3.54405 4.64719 3.56758C4.89313 3.59112 5.12769 3.68255 5.32467 3.83168L8.00355 5.83084C8.20122 5.98125 8.43698 6.07343 8.68425 6.09698C8.93152 6.12053 9.18045 6.07451 9.40296 5.96412L12.1951 4.59136C12.5519 4.41149 12.963 4.3711 13.348 4.47807L13.9944 4.66466C14.1279 4.70175 14.2515 4.76813 14.3562 4.85898C14.4609 4.94983 14.544 5.06287 14.5996 5.18987C14.6551 5.31687 14.6816 5.45465 14.6772 5.59319C14.6728 5.73173 14.6376 5.86755 14.5741 5.99077L14.3209 6.49723C14.1676 6.80376 13.9211 7.05699 13.6079 7.21692L5.05145 11.4618C4.79985 11.5864 4.51532 11.6284 4.23846 11.5818V11.5951Z",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_3987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9933,
    height: 15.9933,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlan);
export default __webpack_public_path__ + "static/media/blue_plan.f8eaf83f807ea752978b43da27934111.svg";
export { ForwardRef as ReactComponent };